import * as React from 'react'
import { memo, useState } from 'react'
import { useOnClickOutside } from 'usehooks-ts'

import { useReject } from './hooks'
import { setReject, submitReject } from './model'
import {
  CButton,
  CCol,
  CForm,
  CFormCheck,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react-pro'
import { transactionRequestDestinationType } from '../../../const'
import { Alert, Button, Divider, Tag } from 'antd'
import { InternalTransferEdit } from '../../list/types'

type Props = {
  request: InternalTransferEdit
  className?: string
  color?: string
  disabled?: boolean
}
type RadioProps = {
  ref?: React.Ref<HTMLDivElement> | undefined
  value: string
  label: string
  reasonName: string
  className?: string
  color?: string
  disabled?: boolean
}

export const RejectModal = ({ request, className, color, disabled }: Props) => {
  const { reject, isLoading } = useReject()
  const [isVisible, setVisible] = React.useState(false)
  const ref = React.useRef(null)

  useOnClickOutside(ref, () => {
    if (isVisible) {
      setReject({ rejectReason: '' })
    }
  })

  const [reason, setReason] = useState('')

  // @ts-ignore
  return (
    <>
      <Button
        type="primary"
        danger
        className={className}
        onClick={() => setVisible(true)}
        disabled={disabled}
      >
        Reject
      </Button>
      <CModal visible={isVisible} onClose={() => setVisible(false)} size={'xl'}>
        <CForm
          className="row g-3 needs-validation"
          noValidate
          onSubmit={(e) => {
            const form = e.currentTarget
            if (reject.rejectReason.length == 0) {
              setReason('Please enter a reason')
              e.preventDefault()
              e.stopPropagation()
              return
            }
            e.preventDefault()
            setReason('')
            submitReject({
              requestId: request.transferId,
              // @ts-ignore
              manualTransferReason: reject.rejectReason,
            })
            setVisible(false)
          }}
          id="questionForm"
        >
          <CModalHeader>
            <CModalTitle>Set reason</CModalTitle>
          </CModalHeader>
          <CModalBody>
            {reason.length > 0 && <Alert message={reason} type={'error'} />}
            <CFormLabel htmlFor="initialAmount" className="col-12">
              Rejection reason
            </CFormLabel>
            <CFormInput
              type="text"
              id="reason"
              name="reason"
              onChange={(e) => {
                setReject({ rejectReason: e.target.value })
              }}
            />
            <CFormFeedback invalid>Field is required</CFormFeedback>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" onClick={() => setVisible(false)}>
              Cancel
            </CButton>
            <CButton
              color="primary"
              className="px-4"
              type="submit"
              disabled={isLoading}
            >
              {isLoading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              Reject
            </CButton>
          </CModalFooter>
        </CForm>
      </CModal>
    </>
  )
}
